<template>
  <div class="about">
    <h1>PLANNING</h1>
  </div>
</template>
